<template>

<ul>

  <li
    v-for="(item, index) in items"
    :key="`${section}-${index}`"
    v-html="item"/>

</ul>

</template>

<script>
export default {
  name: 'Ul',
  props: {
    section: String,
    items: Array
  }
}
</script>

<style lang="scss" scoped>
ul {
  list-style: none;
  padding: 0;
  margin-bottom: 0;

  li {
    margin: 10px 0;
  }
}
</style>
